import { useLocation, Link, Navigate } from 'react-router-dom';
import logoBt from '../logo-bt.png';
import './confirmation.css';

function ConfirmationPage() {
  const location = useLocation();
  const { email, address, isWaitlist } = location.state || {};

  // Redirect to home if no data (e.g., direct navigation)
  if (!email || !address) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="confirm-page">
      <nav className="confirm-nav">
        <Link to="/" className="confirm-nav-logo-link">
          <img src={logoBt} alt="Blacktop logo" className="confirm-nav-logo" />
        </Link>
      </nav>

      <main className="confirm-main">
        <div className="confirm-card">
          <div className="confirm-icon">✉️</div>
          <h1 className="confirm-title">Check Your Email</h1>
          <p className="confirm-text">
            We've sent a verification link to
          </p>
          <p className="confirm-email">{email}</p>
          <p className="confirm-text">
            {isWaitlist
              ? 'Click the link to confirm your waitlist request for:'
              : 'Click the link to confirm your estimate request for:'}
          </p>
          <p className="confirm-address">{address}</p>
          <div className="confirm-divider" />
          <p className="confirm-footer">
            Didn't receive it? Check your spam folder or contact us at{' '}
            <a href="tel:+12015841818">201-584-1818</a> or{' '}
            <a href="mailto:info@blacktopadvisor.com">info@blacktopadvisor.com</a>.
          </p>
        </div>
      </main>
    </div>
  );
}

export default ConfirmationPage;
